import React, { ComponentProps, forwardRef, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import TreeNode from './TreeNode';
import { IdType, InternalDataNode } from './types';

type TreeProps = StylableComponent<HTMLUListElement> & {
  normalizedTree?: Record<IdType, InternalDataNode>;
  orderedIds?: IdType[];
  getTreeNodeProps?: (
    node: InternalDataNode,
  ) => ComponentProps<typeof TreeNode>;
  children?: ReactNode;
};

const Tree = forwardRef<HTMLUListElement, TreeProps>(
  (
    {
      children,
      normalizedTree = {},
      orderedIds = [],
      getTreeNodeProps = (treeNodeProps) => treeNodeProps,
      style,
      ...props
    },
    ref,
  ) => {
    const { tokens } = useTheme();
    const containerTokens = tokens?.component.tree?.container;

    return (
      <ul ref={ref} css={[containerTokens?._, style]} {...props}>
        {children ||
          orderedIds
            .map((id) => normalizedTree[id])
            .map(getTreeNodeProps)
            .map((node) => <TreeNode key={node.id} {...node} />)}
      </ul>
    );
  },
);

Tree.displayName = 'Tree';

Tree.propTypes = {
  style: stylePropType,
  className: PropTypes.string,
  children: PropTypes.any,
  orderedIds: PropTypes.array,
  normalizedTree: PropTypes.shape({}),
  getTreeNodeProps: PropTypes.func,
};

export default Tree;
